/**
 * Kaufmännisches Runden auf 2 Nachkommastellen.
 *
 * Math.round(1.005 * 100) liefert 100, weil 1.005 als 1.00499999999999989
 * gespeichert wird. Die Normalisierung über toPrecision(12) fängt genau
 * diese Gleitkomma-Artefakte ab, ohne echte Werte zu verfälschen.
 */
export function round2(x: number): number {
  if (!Number.isFinite(x)) return x;
  const vorzeichen = x < 0 ? -1 : 1;
  const betrag = Math.abs(x);
  const skaliert = Number((betrag * 100).toPrecision(12));
  return (vorzeichen * Math.round(skaliert)) / 100;
}

/** Runden auf n Nachkommastellen, für Kennzahlen wie €/km oder l/100km. */
export function roundN(x: number, n: number): number {
  if (!Number.isFinite(x)) return x;
  const f = 10 ** n;
  const vorzeichen = x < 0 ? -1 : 1;
  const skaliert = Number((Math.abs(x) * f).toPrecision(12));
  return (vorzeichen * Math.round(skaliert)) / f;
}

/** Anzeige im deutschen Format, z. B. "181,20 €". */
export function formatEuro(x: number): string {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  })
    .format(round2(x))
    .replace(/\u00A0/g, ' ');
}
